import { useFetchLocationAvailableEvents } from 'api/locations/hooks';
import { useGetRegionPageAvailableEvents } from 'api/regions/hooks';
import { useFetchRetailerPageAvailableEvents, useFetchStore } from 'api/store/hooks';
import { useParams } from 'react-router-dom';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

export const useLocationEventAvailableItems = () => {
  const { locationUid } = useParams();
  const { data, isLoading } = useFetchLocationAvailableEvents(locationUid);

  return { items: data || [], isLoading };
};

export const useStoreEventAvailableItems = () => {
  const { data: store } = useFetchStore();
  const { data, isLoading } = useFetchRetailerPageAvailableEvents(store?.uid, {
    enabled: !!store?.uid,
  });

  return { items: data || [], isLoading };
};

export const useRegionEventAvailableItems = () => {
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { data, isLoading } = useGetRegionPageAvailableEvents(selectedRegion);

  return { items: data || [], isLoading };
};
